import { NgModule } from '@angular/core';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { PageHeaderModule, SelectModule } from '@certemy/ui-components';
import { PdfTemplateFieldComponent } from './pdf-template-field.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [PdfTemplateFieldComponent],
  imports: [CertemyCommonModule, PageHeaderModule, SelectModule, ReactiveFormsModule],
  exports: [PdfTemplateFieldComponent],
})
export class PdfTemplateFieldModule {}
